import Icon from "@material-ui/icons/Business";
import CompanyList from "./CompanyList";
import CompanyCreate from "./CompanyCreate";
import CompanyEdit from "./CompanyEdit";
import CompanyShow from "./CompanyShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "companies",
  create: CompanyCreate,
  list: CompanyList,
  show: CompanyShow,
  edit: CompanyEdit,
  icon: Icon,
};
